import { UseFormReturn } from 'react-hook-form'
import { TemplateUpdateParams } from '../../../../types'
import { Heading, Tabs } from '../../../../ui'
import VariableTextInput from '../../../../ui/form/VariableTextInput'
import JsonField from '../../../../ui/form/JsonField'
import SwitchField from '../../../../ui/form/SwitchField'
import ImageField from '../../../../ui/form/ImageField'
import { useTranslation } from 'react-i18next'
import { ExpiresAtField } from './ExpiresAtField'
import { NoDismissAlert } from './NoDismissAlert'

export const InAppForm = ({ form }: { form: UseFormReturn<TemplateUpdateParams, any> }) => {
    const { t } = useTranslation()
    const { watch } = form
    const dataValue = watch('data')
    const isPopup = dataValue.editor === 'popup'

    const fieldsTab = !isPopup && dataValue.fields?.length > 0
        ? [{
            key: 'fields',
            label: t('fields'),
            children: (
                <>
                    <Heading title={t('fields')} size="h4" />
                    {dataValue.fields.map((field: any) => (
                        field.type === 'image'
                            ? <ImageField
                                key={field.key}
                                form={form}
                                name={`data.custom.${field.key}`}
                                label={field.name}
                            />
                            : <VariableTextInput.Field
                                form={form}
                                name={`data.custom.${field.key}`}
                                key={field.key}
                                label={field.name}
                                multiline={field.type === 'textarea'}
                            />
                    ))}
                </>
            ),
        }]
        : []

    return <Tabs tabs={[
        {
            key: 'general',
            label: t('general'),
            children: (
                <>
                    <Heading title={t('general')} size="h4" />
                    <input type="hidden" {...form.register('data.type')} value="html" />
                    {isPopup && <input type="hidden" {...form.register('data.editor')} value="popup" />}
                    <VariableTextInput.Field
                        form={form}
                        name="data.title"
                        label={t('title')}
                        required />
                    <VariableTextInput.Field
                        form={form}
                        name="data.body"
                        label={t('body')}
                        multiline
                        required />
                </>
            ),
        },
        ...fieldsTab,
        {
            key: 'advanced',
            label: t('advanced'),
            children: (
                <>
                    <Heading title={t('advanced')} size="h4" />
                    <ExpiresAtField form={form} />
                    <SwitchField
                        form={form}
                        name="data.expires_in_user_timezone"
                        label={t('expires_in_user_timezone')}
                        subtitle={t('expires_in_user_timezone_desc')} />
                    <NoDismissAlert data={dataValue} />
                    <SwitchField
                        form={form}
                        name="data.read_on_show"
                        label={t('read_on_view')}
                        subtitle={t('read_on_view_desc')} />
                    {!isPopup && dataValue?.fields && <JsonField
                        form={form}
                        name="data.custom"
                        label={t('raw_json')}
                        textarea />}
                </>
            ),
        },
    ]} />
}
